import React from 'react';
import styles from './InputVariants.module.css';
import Spinner from '../../../Common/Spinner';
const InputVariant1 = (props) => {
  const h = props.variantInputHeight ? { height: `${props.variantInputHeight}px`, boxSizing: 'border-box' } : {};
  return (
    <div className={styles.varriant1} style={h}>
      <input
        onKeyDown={props.handleOnKeyDown}
        disabled={props.variantDisabled}
        onChange={props.handleChange}
        value={props.searchValue}
        id={`superSearchInputField_${props.variantID}`}
        type="text"
        autoComplete="off"
        className={styles.varriant1_input}
        placeholder={props.variantPlaceholder}
        style={h}
      />
      {
        props.searchValue ? (
          <button type="button" className={styles.varriant1_icon} disabled={props.variantDisabled} style={{ background: props.variantThemeColor }} onClick={props.resetComponent}   >
            {props.loading ? <Spinner /> : props.variantCrossIcon}
          </button>
        ) : (
          <button type="button" disabled={props.variantDisabled} className={styles.varriant1_icon} style={{ background: props.variantThemeColor }}>
            {props.variantSearchIcon}
          </button>
        )
      }
    </div>
  );
};

export default InputVariant1;
